import React from 'react'

import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import {
  FilterSectionWithDrawer,
  FilterSectionWithDrawerProps,
  FilterWithSidebar,
  FilterWithSidebarProps,
  MobileFilters,
  UpdateQueryParams,
} from '@src/quince-components/src/atoms/filterSection/menu'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { COLOR_PAGES_RENDERED_PATHS } from '../../collection.constants'
import Collection, { COLLECTION_PAGE_TYPE, SubCollection } from '../../domains/Collection'
import { Filter, SelectedFilter } from '../../domains/CollectionFilter'
import { IProductFeedResponseForCollection } from '../../services/collectionService/CollectionService.types'

interface CollectionFiltersProps {
  totalProductsCount: number
  initialFilters: Filter[]
  sortBy: string
  selectedFilters: SelectedFilter
  updateQuery: (params: UpdateQueryParams) => void
  collectionSlug?: string
  collectionPage?: Collection | IProductFeedResponseForCollection
  newCLPFiltersDesktopBucket: STATSIG_EXPERIMENTS_BUCKETS | null
  showLoader?: boolean
  subCollectionCards: SubCollection[]
  filtersContainerClassName?: string
}

const CollectionFilters = ({
  totalProductsCount,
  initialFilters,
  sortBy,
  selectedFilters,
  updateQuery,
  collectionSlug,
  collectionPage,
  newCLPFiltersDesktopBucket,
  showLoader,
  subCollectionCards,
  filtersContainerClassName,
}: CollectionFiltersProps) => {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP

  function getFilterSectionComponent(): React.FC<FilterSectionWithDrawerProps | FilterWithSidebarProps> {
    if (isDesktop) {
      if (newCLPFiltersDesktopBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_B) {
        return FilterWithSidebar
      }
      return FilterSectionWithDrawer
    }

    return MobileFilters
  }

  function renderFilterSection(Component: React.FC<FilterSectionWithDrawerProps | FilterWithSidebarProps>) {
    const isBundleCollection =
      collectionPage && 'collectionPageType' in collectionPage
        ? collectionPage.collectionPageType === COLLECTION_PAGE_TYPE.BUNDLE
        : false

    const baseProps = {
      noOfItems: totalProductsCount,
      filters: initialFilters,
      sortBy: sortBy,
      selectedFilters: selectedFilters,
      updateQuery: updateQuery as (params: UpdateQueryParams) => void,
      showSelectedOption: sortBy !== '',
      shouldRenderColorFilterHtml:
        collectionPage && COLOR_PAGES_RENDERED_PATHS.has('slug' in collectionPage ? collectionPage.slug : ''),
      collectionSlug: collectionSlug ?? (collectionPage && 'slug' in collectionPage ? collectionPage.slug : ''),
      hideFilters: isBundleCollection,
      skipSorting: isBundleCollection,
      showShimmer: showLoader,
      subCollectionCards,
      filtersContainerClassName,
    }

    return <Component {...baseProps} />
  }

  return renderFilterSection(getFilterSectionComponent())
}

export default CollectionFilters
